import StaticValue from '@/modules/common/values/staticValue'
import i18n from '@/i18n'

export default [
  new StaticValue('CZE', i18n.message('value.country.label.CZE')),
  new StaticValue('SVK', i18n.message('value.country.label.SVK'))
]
